import { afterNextRender, Inject, PLATFORM_ID, Renderer2, signal } from '@angular/core';
import { DOCUMENT } from '@angular/common';

import { CdkPageLockComponent } from '@common/cdk-page-lock-component/cdk-page-lock.component';

export abstract class CommonGuideComponent extends CdkPageLockComponent {
  readonly show = signal(false);
  readonly delay = 500;

  abstract get key(): string;

  private intervalId: ReturnType<typeof setTimeout> | undefined;

  protected constructor(@Inject(PLATFORM_ID) id: object, @Inject(DOCUMENT) doc: Document, render: Renderer2) {
    super(id, doc, render);
    afterNextRender(() => {
      this.intervalId = setTimeout(() => {
        try {
          if (localStorage) {
            this.show.set(!localStorage.getItem(this.key));
          } else {
            this.show.set(false);
          }
        } catch {
          this.show.set(false);
        }
        if (this.show()) {
          this.lockPage();
        }
      }, this.delay);
    });
  }

  override onDestroy(): void {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }

  hideGuide(): void {
    try {
      localStorage?.setItem(this.key, 't');
    } catch {
      // ignore
    }
    this.show.set(false);
    this.releasePage();
  }
}
